import React, { useEffect, useMemo, useState } from "react";
import natureBg from "./img/Foto1wilmanatur.jpg";
import "./css/homeLogin.css";
import { useNavigate } from "react-router-dom";
import { getTodos } from "./api/toDoApi";
import { getJokeOfTheDay } from "./api/jokeApi";
import { useLang } from "./hooks/useLang";
import { DICT } from "./i18n";

function HomeLogin() {
  const API_BASE = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";
  const navigate = useNavigate();
  const [lang, setLang] = useLang(); 
  const t = DICT[lang] ?? DICT.sv;
  const [tasks, setTasks] = useState([]);
  const [todoLoading, setTodoLoading] = useState(false);
  const [todoError, setTodoError] = useState("");
  const [joke, setJoke] = useState("");
  const [jokeLoading, setJokeLoading] = useState(false);
  const [jokeError, setJokeError] = useState("");

  useEffect(() => {
   
    (async () => {
      setTodoLoading(true);
      setTodoError("");
      try {
        const data = await getTodos();
        setTasks(Array.isArray(data) ? data : []);
      } catch (e) {
        setTodoError(e?.message || "Kunde inte hämta to-do.");
      } finally {
        setTodoLoading(false);
      }
    })();

    (async () => {
      setJokeLoading(true);
      setJokeError("");
      try {
        const data = await getJokeOfTheDay();
        
        const j = typeof data === "string" ? data : data?.joke;
        setJoke(j || "");
      } catch (e) {
        setJokeError(e?.message || "Kunde inte hämta skämt.");
      } finally {
        setJokeLoading(false);
      }
    })();
  }, []);

  const topTask = useMemo(() => {
    if (!Array.isArray(tasks) || tasks.length === 0) return null;

    
    const copy = [...tasks];
    copy.sort((a, b) => {
      
      if (Number(a.done) !== Number(b.done)) return Number(a.done) - Number(b.done);
      
      return Number(b.urgency || 0) - Number(a.urgency || 0);
    });

    return copy[0] || null;
  }, [tasks]);

  return (
    <div className="page">
      <div className="page-bg" style={{ backgroundImage: `url(${natureBg})` }} />

      <div className="page-content file-page">
        <header className="file-header">{t.title}</header>

        <aside className="sidebar">
          <img
            src={require("./img/treetop.png")}
            alt="tree top"
            className="sidebar-tree"
          />

          <div className="sidebar-logo-wrapper">
            <img
              src={require("./img/svk.png")}
              alt="logo"
              className="sidebar-logo"
            />
            <div className="sidebar-logo-bubble">{t.welcome}</div>
          </div>

          <button className="menu-btn" onClick={() => navigate("/file")}>
            {t.files}
          </button>
          <button className="menu-btn" onClick={() => navigate("/todo")}>
            {t.todo}
          </button>
          <button className="menu-btn" onClick={() => navigate("/inventory")}>
            {t.inventory}
          </button>
          <button className="menu-btn" onClick={() => navigate("/")}>
            {t.website}
          </button>
        </aside>

        <main className="file-content">
          <div className="home-grid">
            <div className="home-box home-box--todo" onClick={() => navigate("/todo")}>
              <div className="home-box-title">{t.topTodo}</div>

              {todoLoading ? (
                <div className="home-box-muted">{t.loading}</div>
              ) : todoError ? (
                <div className="home-box-muted">{todoError}</div>
              ) : topTask ? (
                <div className="home-todo-body">
                  <div className="home-todo-taskTitle">
                    {topTask.title || t.none}
                  </div>

                  <div className="home-todo-meta">
                    <span className="home-pill home-pill--prio">
                      {t.prioLabel}: <strong>{topTask.urgency ?? "—"}</strong>
                    </span>

                    <span className={"home-pill " + (topTask.done ? "home-pill--done" : "home-pill--open")}>
                      {topTask.done ? (lang === "sv" ? "Klar" : "Done") : (lang === "sv" ? "Ogjord" : "Undone")}
                    </span>
                  </div>

                  <div className="home-todo-cta">
                    {t.openTodo} →
                  </div>
                </div>
              )  : (
                <div className="home-box-muted">{t.none}</div>
              )}
            </div>
            
            <div
              className="home-box"
              onClick={() => setLang((prev) => (prev === "sv" ? "en" : "sv"))}
              title="Toggle language"
            >
              <div style={{ display: "grid", gap: 8 }}>
                <div style={{ fontWeight: 900 }}>{t.language}</div>
                <div style={{ textDecoration: "underline" }}>{t.languageBtn}</div>
              </div>
            </div>

            <div className="home-box" onClick={() => alert(joke || "—")}>
              <div style={{ fontWeight: 900, marginBottom: 8 }}>{t.joke}</div>

              {jokeLoading ? (
                <div>{t.loading}</div>
              ) : jokeError ? (
                <div>{jokeError}</div>
              ) : joke ? (
                <div style={{ fontSize: "1.05rem", lineHeight: 1.2 }}>
                  {joke}
                </div>
              ) : (
                <div>{t.none}</div>
              )}
            </div>
            <div className="home-box" onClick={() => { window.location.href = '/admin/';}}>
              Admin
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default HomeLogin;
